export class EnhancedEcommerce {
  addProductImpressions(products: Array<object>): void {
    const impressions: Array<object> = [];

    window.dataLayer.push({
      'ecommerce': {
        'currencyCode': 'EUR',
        'impressions': impressions
      }
    });

    products.forEach((p, i) => {
      impressions.push({
        'name': p['name'],
        'id': p['sku'],
        'price': p['final_price_incl_tax'],
        'brand': p['brand'],
        'sku': p['sku'],
        'category': p.hasOwnProperty('category_names') ? p['category_names'].join(' / ') : '',
        'variant': '',
        'list': 'product-list',
        'position': (i + 1)
      });
    });
  }

  addProductClick(product: object, index: string | number | boolean | symbol): void {
    window.dataLayer.push({
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'actionField': {'list': 'product-list'},
          'products': [{
            'name': product['name'],
            'id': product['sku'],
            'price': product['final_price_incl_tax'],
            'brand': product['brand'],
            'category': product.hasOwnProperty('category_names') ? product['category_names'].join(' / ') : '',
            'variant': '',
            'position': (index as number) + 1
          }]
        }
      }
    });
  }

  addProductDetail(product: object): void {
    window.dataLayer.push({
      'ecommerce': {
        'detail': {
          'products': [{
            'name': product['name'],
            'id': product['sku'],
            'price': product['final_price_incl_tax'],
            'brand': product['brand'],
            'category': product.hasOwnProperty('category_names') ? product['category_names'].join(' / ') : '',
            'variant': ''
          }]
        }
      }
    });
  }

  addProductAddToCart(product: object, qty: number = 1): void {
    window.dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'EUR',
        'add': {
          'products': [{
            'name': product['name'],
            'id': product['sku'],
            'price': product['final_price_incl_tax'],
            'brand': product['brand'],
            'category': product.hasOwnProperty('category_names') ? product['category_names'].join(' / ') : '',
            'variant': '',
            'quantity': qty
          }]
        }
      }
    });
  }

  addProductRemoveFromCart(product: object): void {
    window.dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {
          'products': [{
            'name': product['name'],
            'id': product['sku'],
            'price': product['row_total_incl_tax'],
            'brand': '',
            'category': '',
            'variant': '',
            'quantity': product['qty']
          }]
        }
      }
    });
  }

  addCheckout(products: Array<object>, step: number, option: string = ''): void {
    const productList: Array<object> = [];

    if (step === 1) {
      window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': step, 'option': option},
            'products': productList
          }
        }
      });

      products.forEach(p => {
        productList.push({
          'name': p['name'],
          'id': p['sku'],
          'price': p['row_total_incl_tax'],
          'brand': '',
          'category': '',
          'variant': '',
          'quantity': p['qty']
        });
      });
    } else {
      window.dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
          'checkout_option': {
            'actionField': {'step': step, 'option': option}
          }
        }
      });
    }
  }
}

const enhancedEcommerce = new EnhancedEcommerce();

export {enhancedEcommerce};
